import { getTheme } from '../../utils/getTheme';
import { ColorsPalette } from './colors.palette';
import { typography } from './typography';

const borderRadius = '5rem';

export const theme = getTheme(ColorsPalette, typography, borderRadius);
